import {i18n} from '@zui/core';

i18n.addLang({
    'zh_cn': {
        selectAll: '全选',
        cancelSelect: '取消选择',
        searchEmptyHint: '无匹配选项',
        loadingHint: '正在加载...',
    },
    'zh_tw': {
        selectAll: '全選',
        cancelSelect: '取消選擇',
        searchEmptyHint: '無匹配選項',
        loadingHint: '正在載入...',
    },
    en: {
        selectAll: 'Select All',
        cancelSelect: 'Cancel Select',
        searchEmptyHint: 'No matching options',
        loadingHint: 'Loading...',
    },
});
